/**
 * 더미 JSON 샘플 데이터
 * 실제 API 대신 사용되는 모의 데이터
 */

// 대시보드 통계 데이터
export const mockDashboardData = {
  overview: {
    total_users: 1247,
    total_active_spots: 23,
    total_notifications_today: 156,
    total_visits_this_month: 3421,
  },
  top_spots: [
    {
      id: 1,
      uuid: 'spot-001',
      spot_name: '제주 한라산 정상',
      visit_count: 892,
      unique_visitors: 456,
      avg_measurement: 48500.25,
      max_measurement: 52100.50,
      min_measurement: 45200.00,
      max_measurement_timestamp: '2024-01-15T14:32:00Z',
      min_measurement_timestamp: '2024-01-10T09:15:00Z',
    },
    {
      id: 2,
      uuid: 'spot-002',
      spot_name: '성산일출봉',
      visit_count: 756,
      unique_visitors: 389,
      avg_measurement: 51200.75,
      max_measurement: 54800.00,
      min_measurement: 47800.25,
      max_measurement_timestamp: '2024-01-14T06:20:00Z',
      min_measurement_timestamp: '2024-01-12T15:45:00Z',
    },
    {
      id: 3,
      uuid: 'spot-003',
      spot_name: '천지연폭포',
      visit_count: 634,
      unique_visitors: 312,
      avg_measurement: 46800.50,
      max_measurement: 49500.75,
      min_measurement: 44100.00,
      max_measurement_timestamp: '2024-01-13T11:30:00Z',
      min_measurement_timestamp: '2024-01-11T16:20:00Z',
    },
    {
      id: 4,
      uuid: 'spot-004',
      spot_name: '용두암',
      visit_count: 523,
      unique_visitors: 267,
      avg_measurement: 49500.00,
      max_measurement: 52800.25,
      min_measurement: 46200.50,
      max_measurement_timestamp: '2024-01-12T10:15:00Z',
      min_measurement_timestamp: '2024-01-09T14:50:00Z',
    },
    {
      id: 5,
      uuid: 'spot-005',
      spot_name: '우도',
      visit_count: 456,
      unique_visitors: 234,
      avg_measurement: 47800.75,
      max_measurement: 51200.00,
      min_measurement: 44400.25,
      max_measurement_timestamp: '2024-01-11T13:25:00Z',
      min_measurement_timestamp: '2024-01-08T09:40:00Z',
    },
  ],
};

// 스팟 목록 데이터
export const mockSpotsData = [
  {
    id: 1,
    uuid: 'spot-001',
    spot_name: '제주 한라산 정상',
    spot_name_en: 'Hallasan Peak',
    latitude: 33.3617,
    longitude: 126.5331,
    magnetic_field_strength: 'medium',
    nanotesla_value: 48500.00,
    geofence_radius_meters: 100,
    short_description: '제주도의 최고봉으로 유명한 한라산 정상입니다.',
    detailed_benefits: '한라산 정상의 특별한 자기장 환경은 몸의 순환을 돕고, 스트레스 해소에 도움을 줍니다. 높은 고도에서 느끼는 깨끗한 공기와 함께 자연 치유력을 경험할 수 있습니다.',
    address: '제주특별자치도 제주시 1100로 2894-78',
    region: '제주',
    is_active: true,
  },
  {
    id: 2,
    uuid: 'spot-002',
    spot_name: '성산일출봉',
    spot_name_en: 'Seongsan Ilchulbong',
    latitude: 33.4583,
    longitude: 126.9425,
    magnetic_field_strength: 'strong',
    nanotesla_value: 51200.00,
    geofence_radius_meters: 150,
    short_description: '일출로 유명한 성산일출봉입니다.',
    detailed_benefits: '성산일출봉의 강한 자기장은 에너지 회복과 면역력 향상에 도움을 줍니다. 아침 일출과 함께 하는 명상은 정신적 안정을 가져다줍니다.',
    address: '제주특별자치도 서귀포시 성산읍 성산리',
    region: '서귀포',
    is_active: true,
  },
  {
    id: 3,
    uuid: 'spot-003',
    spot_name: '천지연폭포',
    spot_name_en: 'Cheonjiyeon Falls',
    latitude: 33.2403,
    longitude: 126.5603,
    magnetic_field_strength: 'medium',
    nanotesla_value: 46800.00,
    geofence_radius_meters: 80,
    short_description: '아름다운 폭포와 주변 자연 환경이 조화를 이루는 곳입니다.',
    detailed_benefits: '천지연폭포 주변의 중간 강도 자기장은 피로 회복과 수면 개선에 효과적입니다. 폭포의 음이온과 함께 자연 치유력을 경험할 수 있습니다.',
    address: '제주특별자치도 서귀포시 천지동',
    region: '서귀포',
    is_active: true,
  },
  {
    id: 4,
    uuid: 'spot-004',
    spot_name: '용두암',
    spot_name_en: 'Yongduam',
    latitude: 33.5142,
    longitude: 126.5297,
    magnetic_field_strength: 'medium',
    nanotesla_value: 49500.00,
    geofence_radius_meters: 60,
    short_description: '용의 머리 모양을 닮은 독특한 바위입니다.',
    detailed_benefits: '용두암 주변의 자기장은 혈액 순환 개선과 관절 건강에 도움을 줍니다. 바다와 만나는 지점의 특별한 에너지를 느낄 수 있습니다.',
    address: '제주특별자치도 제주시 용담2동',
    region: '제주',
    is_active: true,
  },
  {
    id: 5,
    uuid: 'spot-005',
    spot_name: '우도',
    spot_name_en: 'Udo Island',
    latitude: 33.5069,
    longitude: 126.9531,
    magnetic_field_strength: 'weak',
    nanotesla_value: 47800.00,
    geofence_radius_meters: 200,
    short_description: '소가 누워있는 모양의 아름다운 섬입니다.',
    detailed_benefits: '우도의 약한 자기장 환경은 휴식과 명상에 최적입니다. 섬 전체를 둘러보며 자연의 평화로운 에너지를 느낄 수 있습니다.',
    address: '제주특별자치도 제주시 우도면',
    region: '제주',
    is_active: true,
  },
];

// 센서 데이터 샘플
export const mockSensorData = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  record_uuid: `REC-${String(i + 1).padStart(3, '0')}`,
  created_timestamp_utc: new Date(2024, 0, 15, 14, 30 + i * 2, 0).toISOString(),
  measurement_latitude: 33.3617 + (Math.random() - 0.5) * 0.01,
  measurement_longitude: 126.5331 + (Math.random() - 0.5) * 0.01,
  device_sensor_id: ['Samsung SM-G977N', 'iPhone 14 Pro', 'Pixel 7'][i % 3],
  original_value: 45000 + Math.random() * 10000,
  corrected_value: 45000 + Math.random() * 10000,
  change_actor: '시스템',
  change_timestamp: new Date(2024, 0, 15, 14, 30 + i * 2, 0).toISOString(),
  change_reason: '없음',
  change_version: 1,
  data_integrity_hash: `hash_${i + 1}`,
  audit_log_hash: `audit_${i + 1}`,
}));
